import { Form, Input, Row, Col, Upload, Modal } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useState } from "react";

export default function StepCompany({ logoProps }) {
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    setPreviewImage(file.url || file.preview);
    setPreviewVisible(true);
  };

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Form.Item
            name="bussiness"
            label="Nombre de la empresa"
            rules={[
                {
                  required: true,
                  message: "Debes ingresar el nombre de la organización",
                },
              ]}
            >
            <Input />
          </Form.Item>
        </Col>

        <Col span={24}>
          <Form.Item
            name="rfc"
            label="RFC"
            rules={[{ required: true, message: "Introduce el RFC" }]}
          >
            <Input maxLength={13} minLength={12} />
          </Form.Item>
        </Col>

        <Col span={24}>
          <Form.Item
            name="logo"
            label="Logo de la empresa"
            rules={[{ required: true, message: "Debes agregar tu logo" }]}
          >
            <Upload
              listType="picture-card"
              maxCount={1}
              showUploadList={{ showPreviewIcon: true }}
              onPreview={handlePreview}
              {...logoProps}
            >
              {logoProps.fileList.length >= 1 ? null : (
                <div>
                  <PlusOutlined />
                  <div style={{ marginTop: 8 }}>Subir</div>
                </div>
              )}
            </Upload>
          </Form.Item>
        </Col>
      </Row>

      <Modal
        open={previewVisible}
        footer={null}
        onCancel={() => setPreviewVisible(false)}
      >
        <img
          alt="preview"
          style={{ width: "100%" }}
          src={previewImage}
        />
      </Modal>
    </>
  );
}
